export const ALERT_RULE_TYPES = [
  "no_section_start_after_signup",
  "started_not_completed",
  "dormant_user",
];

export const ALERT_SCHEDULES = ["daily", "weekly"];

const isBlank = (value) => value === null || value === undefined || String(value).trim() === "";

export const validateAlertRule = (form) => {
  const errors = {};

  if (!form.name || !String(form.name).trim()) {
    errors.name = "Name is required.";
  }

  if (!ALERT_RULE_TYPES.includes(form.rule_type)) {
    errors.rule_type = "Rule type is invalid.";
  }

  const threshold = Number(form.threshold_days);
  if (!Number.isFinite(threshold) || threshold < 1) {
    errors.threshold_days = "Threshold days must be at least 1.";
  }

  if (!ALERT_SCHEDULES.includes(form.schedule)) {
    errors.schedule = "Schedule is invalid.";
  }

  if (!isBlank(form.max_deliveries_per_user)) {
    const maxDeliveries = Number(form.max_deliveries_per_user);
    if (!Number.isInteger(maxDeliveries) || maxDeliveries < 1) {
      errors.max_deliveries_per_user =
        "Max deliveries per user must be a whole number of at least 1.";
    }
  }

  if (!isBlank(form.cta_url)) {
    try {
      const url = new URL(String(form.cta_url));
      if (!["http:", "https:"].includes(url.protocol)) {
        errors.cta_url = "CTA URL must start with http:// or https://.";
      }
    } catch {
      errors.cta_url = "CTA URL must be a valid URL.";
    }
  }

  return errors;
};

